<template>
    <div class="jr-cont">
        <div class="jr-item" v-for="(item, i) in 4" v-if="defaultdata[i] && defaultdata[i].value1">
            <img :src="iconMap[i].bg" alt="" class="cirbg">
            <img :src="iconMap[i].icon" alt="" class="jr-bg">
            <div class="jr-text1" :title="defaultdata[i].value2">{{ defaultdata[i].value2 }}</div>
            <div class="jr-text2" :title="defaultdata[i].value1">{{ defaultdata[i].value1 }}</div>
        </div>
    </div>
</template>

<script>
import icon1 from '@/assets/temimg4/jr-icon1.png'
import icon2 from '@/assets/temimg4/jr-icon2.png'
import icon3 from '@/assets/temimg4/jr-icon3.png'
import icon4 from '@/assets/temimg4/jr-icon4.png'
import cbg1 from '@/assets/temimg4/cirbg2.png'
import cbg2 from '@/assets/temimg4/cirbg1.png'

import * as methods from "./method.js";
export default {
    name: "template.scope132",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            iconMap: [
                { icon: icon1, bg: cbg1 },
                { icon: icon2, bg: cbg2 },
                { icon: icon3, bg: cbg2 },
                { icon: icon4, bg: cbg1 },
            ],
            defaultdata: [
                { value1: '文本一', value2: '000' },
                { value1: '文本二', value2: '000' },
                { value1: '文本三', value2: '000' },
                { value1: '文本四', value2: '000' },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
        },
    },
    methods: {
        ...methods
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
    },
}
</script>

<style lang="scss" scoped>
.jr-cont {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    column-gap: 36px;
    row-gap: 14px;
    align-items: center;
    .jr-item {
        width: 190px;
        height: 70px;
        position: relative;
        padding-left: 80px;
        box-sizing: border-box;
        .jr-bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
    .jr-text1 {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 21px;
        color: #FFFFFF;
        background: linear-gradient(0deg, #FFFFFF 0%, #00A8FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-top: 8px;
        max-width: 110px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .jr-text2 {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 13px;
        color: #ACBCCB;
        margin-top: 8px;
        max-width: 110px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .cirbg {
        width: 62.5px;
        height: 62.5px;
        position: absolute;
        pointer-events: none;
        left: 2px;
        top: 5px;
        animation: rotate2 5s linear infinite;
    }
}
@keyframes rotate2 {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>